// config/domainConfig.ts

export type DomainType = 'GROWW' | '915';

export const ENVS = {
  NEXT: 'next',
  UAT: 'uat',
  PROD: 'prod',
  LOCAL: 'localhost',
}

export const BASE_DOMAIN = {
  GROWW: 'groww',
  NINE15: '915',
}

export const resolveEnvFlavour = (hostname?: string): string => {
  const host =
    typeof window !== 'undefined'
      ? (hostname ?? window.location.hostname ?? '')
      : hostname ?? '';

  if (!host) {
    return ENV_FLAVOUR;
  }

  if (host.includes(ENVS.LOCAL) || host.includes('127.0.0.1')) {
    return 'local';
  }
  if (host.includes(ENVS.UAT)) {
    return ENVS.UAT;
  }
  if (host.includes(ENVS.NEXT) || host.includes('release.groww.in')) {
    return ENVS.NEXT;
  }
  return ENVS.PROD;
};

export const DOMAIN_CONFIG = {
  GROWW: {
    host: GROWW_HOST,
    apiServerUrl: GROWW_API_SERVER_URL,
    checksumKey: GROWW_CHECKSUM_SALT,
    appId: 'GrowwWeb',
  },
  '915': {
    host: NINE15_HOST,
    apiServerUrl: NINE15_API_SERVER_URL,
    checksumKey: NINE15_CHECKSUM_SALT,
    appId: '915Web',
  }
};

/**
 * Resolves the API base URL at runtime from the actual hostname.
 * Values come from env files (injected at build time for all envs),
 * so no URLs are hardcoded here.
 */
export const resolveApiBaseUrl = (host: string): string => {
  const is915 = host?.includes(BASE_DOMAIN.NINE15);

  if (host.includes(ENVS.NEXT)) return is915 ? NINE15_API_URL_NEXT : GROWW_API_URL_NEXT;
  if (host.includes(ENVS.UAT)) return is915 ? NINE15_API_URL_UAT : GROWW_API_URL_UAT;
  if (!host.includes(ENVS.LOCAL) && !host.includes('127.0.0.1')) {
    return is915 ? NINE15_API_URL_PROD : GROWW_API_URL_PROD;
  }
  return is915 ? NINE15_API_URL_LOCAL : GROWW_API_URL_LOCAL;
};

export const resolveHoistKey = (host: string): string => {

  const is915 = host.includes(BASE_DOMAIN.NINE15);
  if (host.includes(ENVS.NEXT)) return is915 ? NINE15_HOIST_API_KEY_NEXT : GROWW_HOIST_API_KEY_NEXT;
  if (host.includes(ENVS.UAT)) return is915 ? NINE15_HOIST_API_KEY_UAT : GROWW_HOIST_API_KEY_UAT;
  if (!host.includes(ENVS.LOCAL) && !host.includes('127.0.0.1')) {
    return is915 ? NINE15_HOIST_API_KEY_PROD : GROWW_HOIST_API_KEY_PROD;
  }
  return is915 ? NINE15_HOIST_API_KEY_LOCAL : GROWW_HOIST_API_KEY_LOCAL;
};

export const resolveGobblerApiUrl = (host: string): string => {
  if (host.includes(ENVS.NEXT) || host.includes('release.groww.in')) {
    return ENV_GOBBLER_API_URL_NEXT;
  }
  if (host.includes(ENVS.UAT)) {
    return ENV_GOBBLER_API_URL_UAT;
  }
  if (host.includes(ENVS.LOCAL) || host.includes('127.0.0.1')) {
    return ENV_GOBBLER_API_URL_LOCAL;
  }
  return ENV_GOBBLER_API_URL_PROD;
};

export const resolveGobblerApiKey = (host: string): string => {
  if (host.includes(ENVS.NEXT) || host.includes('release.groww.in')) {
    return ENV_GOBBLER_API_KEY_NEXT;
  }
  if (host.includes(ENVS.UAT)) {
    return ENV_GOBBLER_API_KEY_UAT;
  }
  if (host.includes(ENVS.LOCAL) || host.includes('127.0.0.1')) {
    return ENV_GOBBLER_API_KEY_LOCAL;
  }
  return ENV_GOBBLER_API_KEY_PROD;
};
export const resolveGobblerV2ApiUrl = (host: string): string => {
  if (host.includes(ENVS.NEXT) || host.includes('release.groww.in')) {
    return ENV_GOBBLER_V2_API_URL_NEXT;
  }
  if (host.includes(ENVS.UAT)) {
    return ENV_GOBBLER_V2_API_URL_UAT;
  }
  if (host.includes(ENVS.LOCAL) || host.includes('127.0.0.1')) {
    return ENV_GOBBLER_V2_API_URL_LOCAL;
  }
  return ENV_GOBBLER_V2_API_URL_PROD;
};

export const resolveGobblerV2ApiKey = (host: string): string => {
  if (host.includes(ENVS.NEXT) || host.includes('release.groww.in')) {
    return ENV_GOBBLER_V2_API_KEY_NEXT;
  }
  if (host.includes(ENVS.UAT)) {
    return ENV_GOBBLER_V2_API_KEY_UAT;
  }
  if (host.includes(ENVS.LOCAL) || host.includes('127.0.0.1')) {
    return ENV_GOBBLER_V2_API_KEY_LOCAL;
  }
  return ENV_GOBBLER_V2_API_KEY_PROD;
};

export const getDomainConfig = (hostname?: string) => {
  const host = typeof window !== 'undefined'
    ? (hostname || window.location.hostname)
    : hostname || '';

  const is915 = host.includes(BASE_DOMAIN.NINE15);
  return {
    ...(is915 ? DOMAIN_CONFIG['915'] : DOMAIN_CONFIG.GROWW),
    hoistApiKey: resolveHoistKey(host),
    gobblerApiKey: resolveGobblerApiKey(host),
    gobblerApiUrl: resolveGobblerApiUrl(host),
    gobblerV2ApiKey: resolveGobblerV2ApiKey(host),
    gobblerV2ApiUrl: resolveGobblerV2ApiUrl(host),
    apiBaseUrl: resolveApiBaseUrl(host),
    envFlavour: resolveEnvFlavour(host),
  };
};

export const getIsDomain915 = () => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  return host.includes(BASE_DOMAIN.NINE15);
};
